import React from "react";
import * as FiIcons from "react-icons/fi";
import * as LuIcons from "react-icons/lu";
import * as IoIcons from "react-icons/io";
import * as GoIcons from "react-icons/go";
import * as MdIcons from "react-icons/md";
import * as MuiIcons from "@mui/icons-material";
import * as RiIcons from "react-icons/ri";
import * as BiIcons from "react-icons/bi";

// Combine all icon libraries into one object
const allIconLibraries = {
  ...FiIcons,
  ...LuIcons,
  ...IoIcons,
  ...GoIcons,
  ...MdIcons,
  ...MuiIcons,
  ...RiIcons,
  ...BiIcons,
};

export function getIconComponent(iconName, props = {}) {
  // If it's already a component (not a string name)
  if (typeof iconName !== 'string') {
    return React.createElement(iconName, props);
  }

  // Try to find the icon across all libraries
  const IconComponent = allIconLibraries[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in any library`);
    return null;
  }

  return <IconComponent {...props} />;
}